

var _returnParams = require('components/xo-page-components/src/returnParams');

var _index = require('components/xo-models/src/profilemanagement/index');

define(['angular', 'squid/index', 'components/xo-models/src/user/index', 'components/xo-models/src/auth/index', 'components/xo-models/src/onboard/index', 'components/xo-models/src/checkout/index', 'components/xo-return-to-merchant/dist/util'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-end.route', ['squid', 'xomodel.user', 'xomodel.auth', 'xomodel.onboard', 'xomodel.checkout', 'xo-return-to-merchant']).factory('$EndRoute', function ($ComponentRoute, $unresolved, $integration) {

        return $ComponentRoute.extend('EndRoute', {
            name: 'end',
            resolve: {
                action: function action($window, $util, $config, $CheckoutInputDataModel, $AuthModel, $OnboardUserModel, $CheckoutAppDataModel, $CheckoutPayeeModel, $CheckoutCartModel, $CheckoutSessionModel, $ReturnToMerchant, $rootScope, $state, $populate, $q, $FallbackError, $logger, $DeviceInfo) {

                    function returnMethod(merchantPreferences) {
                        if (merchantPreferences) {
                            return merchantPreferences.returnMethod();
                        }
                        return 'GET';
                    }

                    function returnUrl(checkoutAppData, merchantPreferences) {
                        if (checkoutAppData.is_wps_flow() && merchantPreferences) {
                            return checkoutAppData.urls.return_url || merchantPreferences.returnUrl();
                        } else {
                            return checkoutAppData.urls.return_url;
                        }
                    }

                    function getMerchantPreferences(dataModel) {
                        return $populate(dataModel, {
                            merchantPreferences: _index.$MerchantPreferenceModel.instance(dataModel.payee.merchant.id)
                        });
                    }

                    function postToMerchant(wpsURL, wpsData) {
                        $ReturnToMerchant.postTo(wpsURL, wpsData);
                    }

                    function goToMerchant(wpsURL, wpsData) {
                        // if PDT is disabled don't send params in the url
                        if ($state.merchantPreferences && !$state.merchantPreferences.pdtEnabled()) {
                            return $ReturnToMerchant.goTo(wpsURL);
                        }
                        return $ReturnToMerchant.goTo($util.buildURL(wpsURL, wpsData));
                    }

                    return $populate($state, {
                        checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
                        checkoutCart: $CheckoutCartModel.instance($rootScope.token),
                        checkoutSession: $CheckoutSessionModel.instance($rootScope.token),
                        payee: $CheckoutPayeeModel.instance($rootScope.token)
                    }).then(function () {

                        /*
                            If we're in an in-context flow, the parent button
                            iframe may need the access token to continue running
                            and execute the payment (e.g. in 3rd party cookies
                            disabled mode)
                             We reload the auth model, since after the user is
                            onboarded this model is not updated, then pass the
                            access token up. The token will only be passed if
                            we're on the same-domain as the parent button.
                        */

                        if (window.xprops && window.xprops.onAuth) {
                            var auth = $AuthModel.instance();

                            return auth.reload().then(function () {
                                window.xprops.onAuth(auth.access_token);
                            });
                        }
                    }).then(function () {

                        if ($state.checkoutAppData.is_wps_flow()) {
                            return getMerchantPreferences($state);
                        }
                    }).then(function () {

                        // handle the return url with post and get , with and without PDT for WPS alone
                        // PDT - Payment Data Transfer
                        if ($state.checkoutAppData.is_wps_flow()) {
                            var wpsURL = returnUrl($state.checkoutAppData, $state.merchantPreferences);
                            var returnToMerchantMethod = returnMethod($state.merchantPreferences);
                            var isWPSCart = $state.checkoutAppData.flags.is_cart_upload_flow || $state.checkoutAppData.flags.is_shopping_cart_flow;
                            var wpsParams = (0, _returnParams.$returnParams)($state.checkoutCart, $state.checkoutSession, returnToMerchantMethod, 'WPS', isWPSCart);

                            return returnToMerchantMethod === 'POST' ? postToMerchant(wpsURL, wpsParams) : goToMerchant(wpsURL, wpsParams);
                        }

                        var params = {};
                        // Creating the checkoutInputData here so that it would not make payer-id call.
                        var checkoutInputData = $CheckoutInputDataModel.instance($rootScope.token);

                        // Don't post PayerID for RT without purchase
                        if (!$state.checkoutCart.isBillingNoPurchase()) {
                            params.PayerID = $state.checkoutSession.payer.id;
                        }

                        var billingData = $state.checkoutCart.billing;

                        // exclude BA token in the returnUrl for external merchant - (merchant not calling BEAM directly)
                        if (billingData && billingData.ba_token && !$state.checkoutAppData.legacy_billing_integration) {
                            params.ba_token = billingData.ba_token;
                        }

                        // When "redirect_uri" is passed as a query param
                        if ($integration.getConfig('REDIRECT_QUERY_PARAM')) {
                            //  this is specifically for nativexo where redirect_uri is passed in query param
                            //  the following query params need to be appended to the redirect_uri
                            params.return_uri = $state.checkoutAppData.get('urls.return_url');
                            params.opType = 'payment';
                        }

                        function handleRedirection(url) {
                            var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
                            var isMobileDevice = Boolean($DeviceInfo.isDevice() && !isHTTPUrl);

                            /* Webview to App view switching is not happening properly
                            * so to handle , adding a work around by adding cancel / return to merchant url
                            * on success page
                            * routeToComplete is the route which shows cancel / return to merchant url*/
                            if (isMobileDevice) {
                                $logger.info('Switching_Webview_To_App_view', {
                                    url: url
                                });
                                $window.onunload = $window.onbeforeunload = function () {
                                    // leave this blank , having this comment for lint warning - Unexpected Empty Function
                                };
                                $window.location = url;

                                return $state.go('checkout.routeToComplete', {
                                    url: url,
                                    urlType: 'success'
                                });
                            } else {
                                if (window.xchild) {
                                    $logger.done();
                                    $rootScope.$emit('loading');

                                    var xparams = {
                                        paymentToken: $rootScope.token,
                                        orderID: $rootScope.token,
                                        billingToken: params['ba_token'],
                                        payerID: params['PayerID'],
                                        paymentID: params['paymentId'] || $state.checkoutAppData.payment_id,
                                        intent: $state.checkoutCart.payment_action
                                    };

                                    xparams.returnUrl = url;
                                    return window.xprops.onAuthorize(xparams);
                                }
                                $ReturnToMerchant.goTo(url);
                            }

                            return $unresolved;
                        }

                        if (!checkoutInputData.isEbayTxn()) {
                            // non-Ebay/xoon flow
                            return $q.when().then(function () {
                                if ($integration.getConfig('REDIRECT_QUERY_PARAM')) {
                                    var redirect = $util.buildURL($util.param('redirect_uri'));
                                    $logger.info('Nativeapp_Redirection', {
                                        redirect: redirect
                                    });
                                    return handleRedirection($util.buildURL(redirect, params));
                                } else {
                                    return handleRedirection($util.buildURL($state.checkoutAppData.get('urls.return_url'), params));
                                }
                            });
                        } else {
                            // PrOX flow only
                            return $q.when().then(function () {

                                if ($util.param('fromLipp') === 'true') {
                                    var lippParamList = {
                                        client_id: $util.param('client_id'),
                                        scope: $util.param('scope'),
                                        state: $util.param('state'),
                                        redirect_uri: $util.param('redirect_uri'),
                                        metadata_id: $util.param('cart_id')
                                    };
                                    // reroute to LIPP to generate authcode if send from lipp
                                    var lippUrl = $util.buildURL($window.location.protocol + '//' + $window.location.host + $config.urls.lippRedirectUrl, lippParamList);
                                    return $ReturnToMerchant.goTo(lippUrl, true);
                                } else {
                                    // for Prox Signup flow (eBay), generate auth code
                                    var auth = $AuthModel.instance();
                                    $logger.info('prox_exit_login_code_start');

                                    return auth.action('loginCode', {
                                        data: {
                                            user: {},
                                            client: {
                                                client_id: $config.proxStsClientId,
                                                redirect_uri: checkoutInputData.redirect_uri,
                                                scope: checkoutInputData.scope,
                                                id_token: '',
                                                nonce: auth.nonce,
                                                response_type: 'code',
                                                skip_oauth: false,
                                                skip_consent: true,
                                                target_client_id: $util.base64Decode(checkoutInputData.client_id),
                                                visitor_id: auth.visitor_id,
                                                scope_consent_context: 'access_token'
                                            }
                                        }

                                    })['catch'](function (err) {
                                        $logger.error('prox_exit_login_code_error', err);
                                        $ReturnToMerchant.goTo(checkoutInputData.errorUrl(err.message));

                                        return $unresolved;
                                    }).then(function (loginCodeResult) {
                                        if (loginCodeResult && loginCodeResult.data && loginCodeResult.data.code) {
                                            $logger.info('prox_exit_login_code_success');
                                            return handleRedirection(checkoutInputData.successUrl(loginCodeResult.data.code));
                                        } else {
                                            $logger.error('prox_exit_login_code_not_found');
                                            $ReturnToMerchant.goTo(checkoutInputData.errorUrl('auth_code_error'));

                                            return $unresolved;
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            }
        });
    });
});

_returnParams.$returnParams;

_index.$MerchantPreferenceModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-end/route.js
// module id = ./pages/xo-end/route.js
// module chunks = 1